


<template>
  <div class="entRelation" v-title="{title}">
    <div class="header">
      <div class="logo"></div>
      <div class="title">{{ $route.query.type | netDes}}--{{$route.query.name}}</div>
      <!-- <div class="userCenter">试用用户，欢迎您</div> -->
      <div class="relationOptions" @click="showHeaderTip('option')" :class="{active:showOptions}">操作<span class='triangle' :class="{active:showOptions}"></span>
      </div>
    </div>
    <!-- Option_start -->
    <div class="relationOptions_box"  v-show='showOptions'>
      <ul>
        <li v-on:click="exportImageAll()" id="exportImageAll_id">导出全景图</li>
        <!-- <li v-on:click="saveNet()" id="saveNet_id" >保存图谱</li> -->
        <li v-on:click="downExcel()" id="downExcel_id" >下载Excel</li>
        <li @click="viewExcel()" v-if="!showChart">显示列表</li>
        <li @click="viewExcel()" v-else>显示图谱</li>
      </ul>
    </div>
    <div class="network-content" v-show='!showChart'>
      <div class="chartRelation" id="chartRelation" v-bind:style="{width:chartWidth+'px',height:chartHeight+'px'}"></div>
    </div>
    <!-- legend -->
    <div class="legend"  v-show='!showChart'>
      <ul class="legend_ul">
        <li>查询企业</li>
        <li><p class="middle"></p>中间节点企业</li>
        <li><p class="hold"></p>直接或间接控股</li>
        <li><p class="key"></p>关键管理人员</li>
      </ul>
    </div>
    <!-- <div class="viewExcel" @click="viewExcel()"  v-show="showChart">显示列表</div> -->
    <!-- excel页面 -->
    <div class="excel-mask"  v-show='showChart'>
      <table>
        <thead>
          <tr>
            <th width="346">受益所有人</th>
            <th width="344">受益所有人类型</th>
            <th width="290">股权占比</th>
            <th width="220">任职类型</th>
          </tr>
        </thead>
        <tbody v-if= "istable">
          <tr v-for="(value,key) in sortArray">
            <td>{{value.name}}</td>
            <td>{{value.SYRtype}}</td>
            <td>{{value.cgzb}}</td>
            <td>{{value.position}}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="(value,key) in invididual">
            <td>{{value}}</td>
            <td>关键管理人员</td>
            <td>--</td>
            <td>负责人</td>
          </tr>
        </tbody>
      </table>
      <!-- <div class="return-button" @click="viewExcel()">返回图谱</div> -->
    </div>
    <!-- loading -->
    <div class="loadding" v-if="$store.state.loadding">
      <img src="static/images/loading.gif" alt="loading">
    </div>
    <!-- 快速定位 -->
    <div class="ent_search w_b" style="position:fixed;" >
      <div class="ent_search_inner">
        <input type="text" placeholder="输入节点名称，助您快速定位......" @keyup="choose_event($event)" id="quickSearch_id"  v-model.trim="searchLocationName" v-on:focus="focus()" v-on:blur="blur()">
        <i class='search_icon' :class='{active:search_icon}' @click='searchIcon()'></i>
      </div>
      <item-list class="ess_list_type" v-if="$store.state.showlist" @itemZhi="getLocationCompany"></item-list>
    </div>
  </div>
</template>

<script>
    function arrSort (name, minor) {
        return function (o, p) {
          var a, b;
          if (o && p && typeof o === 'object' && typeof p === 'object') {
            a = o[name];
            b = p[name];
            if (a === b) {
              return typeof minor === 'function' ? minor(o, p) : 0;
            }
            if (typeof a === typeof b) {
              return a < b ? 1 : -1;
            }
            return typeof a < typeof b ? 1 : -1;
          } else {
            thro("error");
          }
        }
  }
  export default{
    data(){
      return {
        chart:null,
        chartWidth:0,
        chartHeight:0,
        showChart:true,
        excelJson:[],
        sortArray:[],
        invididual:[],
        searchLocationName:'',
        // 快速定位
        stop_list : true,
        item0:true,
        search_icon:false,
        netLocationName:{},//快速定位,
        istable:false,
        showOptions:false,
        saveTitle:'',
        initial_Array:{},//最原始的节点数据

        net:null,
        initialNodes:null

      }
    },
    computed:{
      title:function(){
        return this.$route.query.name || ''
      }

    },
    methods:{
        downExcel(){
        var _this = this;
        // _this.$store.state.loadding = true;
        var temp_relation = {},tempid_yuan = [],tempid_shan = [],temp = [],temparray = [];
        var relation = _this.chart.exportData(true,true);
        // console.log(relation)
        // 如果有删除的节点
        if(relation.nodes.length != _this.initial_Array.nodes.length){
          for(var i = 0 ;i<relation.nodes.length;i++){
            tempid_shan.push(relation.nodes[i].id)
          }
          for(var i = 0 ;i<_this.initial_Array.nodes.length;i++){
            tempid_yuan.push(_this.initial_Array.nodes[i].id)
          }
          // 找出删除节点的id
          for(var i = 0 ; i<tempid_shan.length;i++){
            temp[tempid_shan[i]] = true
          }

          for(var i = 0 ;i<tempid_yuan.length;i++){
            if(!temp[tempid_yuan[i]]){
              temparray.push(tempid_yuan[i].toString())
            }
          }
          // console.log(temparray)
          for(var i = 0 ; i<temparray.length;i++){
            for(var j = _this.initial_Array.nodes.length-1;j>0;j--){
              if(_this.initial_Array.nodes[j].id == temparray[i]){
                _this.initial_Array.nodes.splice(j,1)
              }
            }
          }
          for(var i = 0 ;i<temparray.length;i++){
             for(var j =_this.initial_Array.links.length-1;j>0;j--){
              if(_this.initial_Array.links[j].from == temparray[i]||_this.initial_Array.links[j].to == temparray[i]){
                _this.initial_Array.links.splice(j,1)
              }
            }
          }
        }
        var links = _this.initial_Array.links;
        var nodes = _this.initial_Array.nodes;
        var pathLength = _this.doubleMap;
        temp_relation = {
          links,
          nodes
        }
        var usrId = localStorage.getItem('usrId');
        var param = {
          uid:usrId,
          buType:"受益所有人",
          title:_this.saveTitle,
          desc:'',
            // 把节点和线传过去
          result:temp_relation
        }
        var relationData = JSON.stringify(param);
        _this.axios.post(_this.api.save_relation,relationData).then(res=>{
            // console.log(res,9999);
          var orderId = res.data.result.order;
          var token = localStorage.getItem('token');
          var userId = localStorage.getItem('userId');
          var type = res.data.result.buType;
          var all_title=res.data.result.title;

          var imgFileName = type+"-"+all_title+_this.Date();

          var url = _this.api.download_exl +"/"+usrId+"/"+orderId+"/"+imgFileName+"?xToken="+token+"&xUserId="+userId;
          console.log(url,8765);
            // window.location.href = url
          var iframe = document.createElement("iframe")
          iframe.style.display = "none";
          iframe.src = url;
          document.body.appendChild(iframe);
        })

      },
      viewExcel(){
        this.showChart = !this.showChart;
        this.chartHeight = document.body.clientHeight - 60;
        this.chartWidth = document.body.clientWidth;

        $("#chartRelation").css({"height":this.chartHeight+"px","width":this.chartWidth+"px"});
        // console.log(this.net,888);
        setTimeout(()=>{
          this.chart = this.makeMap.renderChart(this.net,this.initialNodes);
      },200);
      },
      focus(){
        this.search_icon = true
      },
      blur(){
        this.search_icon = false
      },
      getLocationCompany : function(msg){
        this.searchLocationName = msg.entName;
        this.stop_list = false
        this.item0 = false
        this.$store.state.showlist=false;
        $("#quickSearch_id").focus()
      },
      showHeaderTip(type){
        this.showOptions=!this.showOptions;
      },
      choose_event : function(e){
        var _this = this;
        if(e.keyCode == 13){
          if(this.$store.state.mohuIndex == 0&&this.$store.state.item.length>0&&this.item0&&this.is_enter){
            this.searchLocationName = this.$store.state.item[0];
            this.$store.state.showlist=false;
            this.stop_list = false
            this.item0 = false
          }else if(!this.item0){
            this.selectedEntByLocation(this.searchLocationName);
            this.stop_list = true
            this.item0 = true
            this.is_enter = false
          }else if(this.$store.state.mohuIndex != 0){
            this.searchLocationName = this.$store.state.item[this.$store.state.mohuIndex-1];
            this.stop_list = false
            this.item0 = false
          }
        }else if(e.keyCode == 40){
          if(this.$store.state.item.length!=0){
            this.$store.state.mohuIndex++;
            // 验收
            if(this.$store.state.mohuIndex>this.$store.state.item.length){
              this.$store.state.mohuIndex = 1;
            }
            $("ul.list li").eq(this.$store.state.mohuIndex-1).addClass("cur").siblings().removeClass("cur");
          }
        }else if(e.keyCode == 38){
          if(this.$store.state.item.length!=0){
            this.$store.state.mohuIndex--;
            // 验收
            if(this.$store.state.mohuIndex<=0){
                this.$store.state.mohuIndex = this.$store.state.item.length;
            }
            $("ul.list li").eq(this.$store.state.mohuIndex-1).addClass("cur").siblings().removeClass("cur");
          }
        }else{
          _this.stop_list = true
          _this.item0 = true
        }
      },
      // 快速定位企业
      selectedEntByLocation: function(nodeIds){
        var _this = this;
        setTimeout(function () {   //页面点绘制完后，方可执行
          var nodesArr = _this.chart.nodes();
          var selectArr = [];
          //进行完全比较，否则模糊匹配会有错乱。
          var arrNodes = nodeIds.split("；");
          for(var k=0;k<arrNodes.length;k++){
            var tarNode = arrNodes[k];
            for (var i = 0; i < nodesArr.length; i++) {
                  var data = nodesArr[i].data;
                  if (tarNode && tarNode ==data.name) {
                      selectArr.push(nodesArr[i]);//设置为选中状态
                      // console.log(nodesArr[i])
                  }
              }
          }
          if(selectArr && selectArr.length>0){
            // 进行选择
            _this.chart.selection(selectArr);
            // 进行快速拉近
            _this.chart.zoom(2,false);
            // 进行元素选择
            _this.chart.zoomIn(selectArr,false );
            _this.stop_list = true
            _this.item0 = true
          }
          console.log(99)
        }, 200);
      },
      searchIcon(){
        if(this.$store.state.mohuIndex == 0&&this.$store.state.item.length>0&&this.item0&&this.is_enter){
          this.searchLocationName = this.$store.state.item[0];
          this.$store.state.showlist=false;
          this.stop_list = false
          this.item0 = false
        }else if(!this.item0){
          this.selectedEntByLocation(this.searchLocationName);
          this.stop_list = true
          this.item0 = true
          this.is_enter = false
        }else if(this.$store.state.mohuIndex != 0){
          this.searchLocationName = this.$store.state.item[this.$store.state.mohuIndex-1];
          this.stop_list = false
          this.item0 = false
        }
      },
      // 导出全景图
      exportImageAll: function(){

          document.getElementsByClassName('DVSL-bar-btn-rearrange')[0].children[0].click();

          setTimeout(()=>{
              this.chart.exportAsString("png",(datas,q) => {
                  var a = document.createElement("a");
                  document.body.appendChild(a);
                  a.href = datas;
                  a.target = "_blank";
                  a.download = this.title+".png";  //设定下载名称
                  a.click();
                  console.log(datas)
                  // var imgFileName = this.title + this.Date()
                  // var exportImgCondition = {
                  //   "imgFileName":encodeURIComponent(imgFileName),
                  //   "imgFileType":"png",
                  //   "imgStr":datas.replace("data:image/png;base64,","")
                  //   }
                  // var exportImgparam = JSON.stringify(exportImgCondition);
                  // this.axios.post(this.api.export_img,exportImgparam).then(({data:{result}})=>{
                  //   console.log(result)
                  //   const token = window.localStorage.getItem('token')
                  //   const userId = window.localStorage.getItem('userId')
                  //   top.window.location = `${this.api.export_img_l}/${result}?xToken=${token}&xUserId=${userId}`
                  // })


              },false);
          },50)
        },



      },
    watch:{
      searchLocationName(curval){
        this.$store.state.mainList = false
        if(curval.length>=1&&this.stop_list){
            this.is_enter = true
            this.$store.state.mohuIndex = 0;
            this.$store.state.showlist=false;
            // 清零
            var _this = this ;
            _this.$store.state.item = [];
            if(_this.netLocationName.nodes && _this.netLocationName.nodes.length>0){
              for(var i = 0;i<_this.netLocationName.nodes.length;i++){
                var current = _this.netLocationName.nodes[i].name;
                if(current){
                  if(current.indexOf(curval) != -1){
                    _this.$store.state.showlist=true;
                    if(_this.$store.state.item.length < 6){
                      _this.$store.state.item.push({
                        entName:_this.netLocationName.nodes[i].name
                        });
                    }
                  }
                }
              }
              // console.log(_this.$store.state.item)
              if(_this.$store.state.item.length==0){
                _this.$store.state.showlist=true;
                _this.$store.state.item[0] = "未找到“"+curval+"”"
              }
            }else{
              _this.alert({
                  title:"提示:",
                  content:"数据未加载完，或无节点数据"
              })
              this.$store.state.showlist=false;
            }
        }else{
          this.$store.state.showlist=false;
          this.is_enter = false;
        }
      }
    },
    mounted(){
      var companyName = this.$route.query.name

      var _this = this;
      // console.log(this.$route.query)
      _this.chartHeight = document.body.clientHeight - 60;
      _this.chartWidth = document.body.clientWidth;
      $(window).resize(function() {
        _this.chartHeight = document.body.clientHeight - 60;
        _this.chartWidth = document.body.clientWidth;
      });
      // console.log(_this.chartHeight,_this.chartWidth);
      var condition = {
        "entmark":companyName || "",
        "sign":"tomanynodes"
      };
      if(this.$route.query.isInvididual == 'true'){
        condition['signType'] = "gt"
      }
      condition = JSON.stringify(condition);
      // debugger;
      this.$store.state.loadding = true;
      this.axios.post(_this.api.bennifit_relation,condition).then(res=>{
        if(res.data.code!==200 || res.data.CODE){
          this.alert({
              title:"提示:",
              content:res.data.msg ||res.data.MSG,
              knowCallbck:()=>{
                  this.$router.push({name:'benifitsearch'})
              }
          })
          return
        }

        var data = res.data
        // 将原始数据进行拷贝
        _this.initial_Array = {...data.result};
        _this.$store.state.loadding = false;
        var net = _this.deepC1(data.result);
        // es6 最初的并且线是合并完成之后的result，包括nodes和links&快速定位
        [_this.$store.state.netResult,_this.netLocationName] = [net ,net]

        // 获得输入企业的id
        for(var i = 0;i<net.nodes.length;i++){
          if(net.nodes[i].innode === true){
            _this.saveTitle = net.nodes[i].name
            _this.$store.state.initialNodes.push(net.nodes[i].id.toString())
          }
        }

        var linksAfterMerge = [];
        // 合并线
        $.each(net.links,function(i,value){
          var link = value;
          if(!_this.repeat(linksAfterMerge,link)){
            linksAfterMerge.push(link);
          }
        });
        net.links = linksAfterMerge;

        var netCopy = _this.deepC1(net);
        // 把将合并后的节点和线转化为字典序
        _this.$store.state.jsonSort_node = {};
        $.each(netCopy.nodes,function(i,value){
          var node = value;
          _this.$store.state.jsonSort_node[value.id] = value;
        });
        _this.$store.state.jsonSort_link = {};
        $.each(netCopy.links,function(i,value){
          _this.$store.state.jsonSort_link[value.id] = value
        })
        this.net = net;
        this.initialNodes =_this.$store.state.initialNodes;
        // console.log(net,_this.$store.state.initialNodes,999);
        // zoomchart添加数据
        setTimeout(function(){
          _this.chart = _this.makeMap.renderChart(net,_this.$store.state.initialNodes);
        },200);

        // 个体查询的列表
        if(_this.$route.query.isInvididual == 'true'){
          _this.istable = false
          for(var k in _this.$store.state.jsonSort_node){
            if(_this.$store.state.jsonSort_node[k].innode == false){
              _this.invididual.push(_this.$store.state.jsonSort_node[k].name)
            }
          }
        }else{
            _this.istable = true
         let { nodes, links } = res.data.result;
            // 指向公司的id
        let toID = nodes.filter(elt => elt.innode === true)[0].id;
        // 有效受益人
        let SYRArr = nodes.filter(elt => elt.properties.isSYR === "true");
        // 有效link（指向这个公司的所有关系线）
        let usefulLinks = links.filter(elt => elt.to === toID);
        //找到受益人所在的公司所有的数据
        let finalSYR = SYRArr.map(elt => {

          let positions = new Set([]);
          //  [... new Set(positions)]
          usefulLinks.forEach(info => {
            if (info.from === elt.id) {

              if (info.properties.legal) {
                elt.legal = true;
              };

              if (info.properties.position_desc) {
                positions.add(info.properties.position_desc);
              }
            }
          });

          let position = '';
          if (positions.size !== 0) {
            // position = Array.prototype.join.call(positions, ',')
            positions.forEach(val => position = position + ' ' + val)
          }
          if (elt.legal) position += ' 法人';

          return {
            id: elt.id,
            name: elt.name,position: position ? position : ' --',
            cgzb: elt.properties.cgzb ? `${elt.properties.cgzb}%` : '--',
            SYRtype: elt.properties.SYRtype
          };

        });

        finalSYR = finalSYR.sort(arrSort('cgzb', arrSort('position')));

        this.sortArray = finalSYR;
        // console.log(finalSYR, '处理后的数据企业')
          // _this.istable = true
          // // excel的人员节点
          // var initialArray = []
          // for(var k in _this.$store.state.jsonSort_node){
          //   if(_this.$store.state.jsonSort_node[k].properties.isSYR == 'true'){
          //     for(var j in _this.$store.state.jsonSort_link){
          //       if(_this.$store.state.jsonSort_link[j].from == k ||_this.$store.state.jsonSort_link[j].to == k){
          //         initialArray.push({
          //           node:_this.$store.state.jsonSort_node[k],
          //           link:_this.$store.state.jsonSort_link[j]
          //         })
          //       }
          //     }
          //   }
          // }
          //
          // // ******去重******_this.excelJson
          // for(var i = 0 ; i < initialArray.length ; i++){
          //     for(var j = 0 ; j <_this.excelJson.length ; j++){
          //         if(initialArray[i].node.id == _this.excelJson[j].node.id){
          //           _this.excelJson[j].link.properties =$.extend(_this.excelJson[j].link.properties,initialArray[i].link.properties)
          //           break;
          //         };
          //     }
          //     if(j == _this.excelJson.length){
          //         _this.excelJson.push(initialArray[i])
          //     }
          // }
          // // 通过所有人类型进行排序
          //
          // _this.sortArray = _.sortBy(_this.excelJson,function(n){
          //
          //   return -n.node.properties.cgzb
          // })
          // console.log(_this.sortArray);
        }



      }).catch(err=>{
        console.log(err)
        if(err.data.msg){
          var errInfo = err.data.msg
        }else{
          var errInfo = "内部错误，请联系管理员"
        }
        _this.$store.state.loadding = false;
        _this.alert({
          title:"提示:",
          content:errInfo,
          okText:"确定",
          sureFn:function(){
            window.opener=null;
            window.open('','_self');
            window.close();
          }
        });
      })
    },
    filters:{
      netDes:function(value){
        switch (value){
          case "search":
            return "受益所有人查询";
          case "check":
            return "受益所有人核验";
          case "risk":
            return "企业风险关联视图";
        }
      }
    }
  }
</script>
<style lang="scss">
.footer{
    position: absolute;
    left:0;
    bottom: 20px;
    width: 100%;
    height: 20px;
    font:  16px/20px "微软雅黑";
    text-align: center;
    z-index: 999;
    color: #000;
}
  .entRelation{
    position: relative;
    overflow-y: auto;
    .header{
      width: 100%;
      height:60px;
      background-color:#0c0c31;
      display:-webkit-box;
      display:box;
      position: fixed;
      z-index: 778;
      .logo{
        width: 162px;
        margin-left:20px;
        height:60px;
        background:url('/static/images/anti-logo.png') center no-repeat;
        background-size:cover;
      }
      .title{
        font-size:22px;
        -webkit-box-flex:1;
        color:#fff;
        text-align:center;
        line-height:60px;
        font-weight: 600;
      }
      // .userCenter{
      //   margin-right:20px;
      //   width: 160px;
      //   line-height:60px;
      //   font-size:16px;
      //   color:#fff;
      // }
      .relationOptions{
        margin-right:50px;
        // float: left;
        width: 80px;
        line-height:56px;
        color:#fff;
        font-size:22px;
        font-weight: 600;
        cursor: pointer;
        &.active{
          color:#6699ff;
        }
        &.nofilter{
          margin-left:146px;
        }
      }
      span.triangle{
        border:5px solid #fff;
        border-color:#fff transparent transparent;
        position: relative;
        top:14px;
        left:6px;
        &.active{
          border-color:transparent transparent #6699ff;
          top:-14px;
        }
        &.last{
          top:16px;
          left:28px;
          &.active{
            border-color:transparent transparent #6699ff;
            top:-14px;
          }
        }
      }
    }
    .relationOptions_box{
      width: 150px;
      background:#0c0c31;
      position: fixed;
      top: 64px;
      right: 8px;
      z-index: 799;
      ul{
        padding-top:18px;
        li{
          text-align:center;
          color:#fff;
          height:50px;
          line-height:50px;
          cursor: pointer;
          font-size: 20px;
          font-weight: 600;
        }
      }
    }
    .network-content{
      position: fixed;
      top:0;
      left:0;
      right:0px;
      bottom:0px;
      padding:60px 0 0 0;
      z-index: 10;
      .chartRelation{
        width:100%;
        height:100%;
      }
    }
    .legend{
      width: 220px;
      height: 100px;
      position: fixed;
      right:0px;
      bottom:38px;
      z-index: 78;
      ul>li{
        color:black;
        padding-left:40px;
        height:30px;
        line-height:30px;
        position: relative;
        &:nth-child(1){
          background:url('/static/images/innode_icon_company.png') 4px no-repeat;
          background-size:28px 28px;
        }
        p{
          position: absolute;
          width: 28px;
          height:28px;
          border-radius:50%;
          top:1px;
          left:4px;
          &.middle{
            background-color:lightgray;
          }
          &.hold{
            background-color:#b278e0;
          }
          &.key{
            background-color:#f6bf5f;
          }
        }
      }
    }
    .loadding{
      position:fixed;
      top:0;
      left:0;
      right:0;
      bottom:0;
      text-align:center;
      vertical-align: middle;
      background:#fff;
      z-index:100;
      img{
        position:absolute;
        top:50%;
      }
    }
    // 节点弹框
    .net-hover{
      width: 270px;
      padding:0 0 16px 0;
      border-radius:0;
      background-color:#fff;
      .typeColor{
        padding-left:20px;
        color:#6795c3;
      }
      p.netTitle{
        padding:10px 0 10px 20px;
        width: 270px;
        color:#7aa2dd;
        font-size:16px;
        background-color:#fff;
        border-bottom:1px solid #dce0e6;
      }
      .netContent{
        padding:0 20px;
        .entstatus_1{
          color:#75cede;
          height:0px;
        }
        .entstatus_2{
          color:#ff1010;
          height:0px;
        }
        .entstatus_3{
          color:#999;
          height:0px;
        }
      }
    }
    .transition-layer{
      width: 210px;
      word-break:break-word;
      background-color:#fff;
      padding:10px 10px 10px 20px;
      .typeColor{
        color:#6795c3;
      }

    }
    .transition-riskinfo{

      color:#ff1010;
      height:0;
      .transition-content{
        background-color:#fff;
        padding-left:20px;
      }
    }
    .transition-line{
      width: 260px;
      background-color:#fff;
      padding-left:20px;
      padding-top:5px;
      padding-bottom:5px;
      .relation{
        color:#6795c3;
      }
    }
    .netHoverinvest{
      width: 230px;
      padding-left:20px;
      padding-top:5px;
      padding-bottom:10px;
      background-color:#fff;
      .typeColor{
        color:#6795c3;
      }
    }
    .riskinfo_Temarray{
      font-weight:300;
      color:#73b75e;
      margin-top:10px;
    }
    .viewExcel{
      width: 100px;
      height:46px;
      background-color:#61dcc3;
      color:#fff;
      text-align:center;
      line-height:46px;
      position: fixed;
      top:90px;
      right:20px;
      z-index: 666;
      cursor:pointer ;
    }
    .excel-mask{
      position: fixed;
      top:0;
      left:0;
      right:0px;
      bottom:50px;
      padding:60px 0 0 0;
      z-index: 776;
      overflow-y: auto;
      table{
        width: 1200px;
        margin:30px auto;
        -moz-box-shadow:0px 1px 16px #999;
        -webkit-box-shadow:0px 1px 16px #999;
        box-shadow:0px 1px 16px #999;
        thead>tr>th{
          height: 70px;
          vertical-align: middle;
          color:#333;
          font-weight:normal;
          background-color:#ececec;
          &:nth-child(1){
            padding-left:100px;
          }
        }
        tbody{
          tr>td{
            height:70px;
            vertical-align: middle;
            color:#333;
            font-weight:normal;
            border-bottom:1px solid #eee;
            &:nth-child(1){
              padding-left:100px;
            }
            span>i{
              font-style:normal
            }
            i{
              font-style:normal
            }
          }
        }
      }
      .return-button{
        position: fixed;
        top:90px;
        right:20px;
        width: 100px;
        height:46px;
        text-align:center;
        line-height:46px;
        background-color:#61dcc3;
        color:#fff;
        cursor: pointer;
      }
    }
    .ent_search{
      width: 320px;
      height: 38px;
      position: absolute;
      left:225px;
      top:8px;
      z-index: 788;
      @media screen and (max-width: 1366px) {
        left:190px;
      }
      .ent_search_inner{
        position: relative;
        input{
          width: 100%;
          height:38px;
          border:none;
          color:#fff;
          font-size:16px;
          padding-left:30px;
          background-color:transparent;
          &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
            color: #fff; opacity:0.5;
          }
          &::-moz-placeholder { /* Mozilla Firefox 19 */
            color: #fff; opacity:0.5;
          }
          &:-ms-input-placeholder{
            color: #fff; opacity:0.5;
          }
          &::-webkit-input-placeholder{
            color: #fff; opacity:0.5;
          }
        }
        i.search_icon{
          position: absolute;
          top:6px;
          left:0;
          width: 27px;
          height:27px;
          background: url(/static/images/icon-Location.png) no-repeat;
          &.active{
            background: url(/static/images/icon-Location-active.png) no-repeat;
          }
        }
      }
      &.w_b .item_list.ess_list_type{
        width:500px;
        top:50px;
        left:-25px;
        background-color: #0c0c31;
        @media screen and (max-width: 1366px) {
          left:-30px;
          width:400px;
        }
        ul.list li{
          padding-left:52px;
          font-size:16px;
          color:#fff;
          @media screen and (max-width: 1366px) {
            padding-left:54px;
          }
          &.cur{
            background-color:rgba(255,255,255,0.1);
          }
          &:hover{
            background-color:rgba(255,255,255,0.1);
          }
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// EntRelation.vue?6341bfde